module.exports = __webpack_public_path__ + "img/RS-J-16.e52826d4.svg";